import type { EventScheduleForStationeryFragment } from '@graphql/generated';
import { useEventWithScheduleQuery } from '@graphql/generated';

export type EventSchedule = EventScheduleForStationeryFragment;

export function useFirstScheduleItem(eventHandle: string): { firstScheduleItem: EventSchedule | undefined; loading: boolean } {
  const { data, loading } = useEventWithScheduleQuery({
    batchMode: 'fast',
    variables: {
      eventHandle: eventHandle ?? '',
    },
    skip: !eventHandle,
  });
  return {
    firstScheduleItem: data?.eventByName?.info.schedule.items?.[0],
    loading,
  };
}
